import React, { useEffect, useReducer, useState, useRef } from "react";
import { Modal, Button, Form, Row, Col, CloseButton  } from "react-bootstrap";
import {
  ACTIONS,
  MAX_LEN,
  createInitialData,
  feedbackFormReducer,
  clearErrorMessages,
  addErrorMessages,
  getFieldValue,
} from "./FeedbackFormReducer";
import { submitFeedback } from "./FeedbackAxiosFuncs";

import { ReactComponent as LikeIcon } from "../../../Images/public/feedback/LikeIcon.svg";
import { ReactComponent as DislikeIcon } from "../../../Images/public/feedback/DislikeIcon.svg";
import { ReactComponent as LikeSelectedIcon } from "../../../Images/public/feedback/LikeSelectedIcon.svg";
import { ReactComponent as DislikeSelectedIcon } from "../../../Images/public/feedback/DislikeSelectedIcon.svg";
import {TextButton} from "../../Button";
import { PageInfo } from "../../PageInformation/PageInformation";

const FeedbackModal = ({ show, onHide }) => {
  const initial = {
    data: createInitialData(),
    loading: false,
    error: null,
  };
  const [formInfo, dispatch] = useReducer(feedbackFormReducer, initial);
  const closeBtnRef = useRef(null);
  const submitBtnRef = useRef(null);
  
  useEffect(() => {
    if (!show) {
      dispatch({
        type: ACTIONS.SET_INITIAL_DATA,
        data: createInitialData(),
        loading: false,
      });
    }
  }, [show]);
  
  const handleRatingSelect = (val) => {
    clearErrorMessages(dispatch, ACTIONS);
    dispatch({ type: ACTIONS.RADIO_CHANGE, name: "rating", value: val });
  };
  const handleCommentChange = (e) => {
    clearErrorMessages(dispatch, ACTIONS);
    dispatch({ type: ACTIONS.TEXT_CHANGE, name: "comment", value: e.target.value });
  };
  
  const likeSelected = <LikeSelectedIcon />;
  const like = <LikeIcon />;
  const dislikeSelected = <DislikeSelectedIcon />;
  const dislike = <DislikeIcon />;
  
  const ratingSelected = formInfo?.data?.rating?.selectedValue;
  const comment = formInfo?.data?.comment?.value ?? "";
  
  const isFormView = formInfo?.data?.submitView?.value === "form";
  const isSuccessView = formInfo?.data?.submitView?.value === "success";
  const isErrorView = formInfo?.data?.submitView?.value === "error";
  
  
  useEffect(() => {
    if (isSuccessView) {
      closeBtnRef.current?.focus();
    } else if (isErrorView) {
      submitBtnRef.current?.focus?.();
    }
  }, [isSuccessView, isErrorView]);
  
  const validate = () => {
    clearErrorMessages(dispatch, ACTIONS);
    let ok = true;
    
    if (ratingSelected !== 0 && ratingSelected !== 1) {
      const message = "Please select Like or Dislike.";
      dispatch({ type: ACTIONS.ERROR, error: {}, message });
      ok = false;
    }
    if (comment && comment.length > MAX_LEN) {
      addErrorMessages(dispatch, ACTIONS, "comment", [
        `Comment cannot exceed ${MAX_LEN} characters.`,
      ]);
      ok = false;
    }
    return ok;
  };
  
  const handleSubmit = async () => {
    
    clearErrorMessages(dispatch, ACTIONS);
    if (!validate()) return;
    
    dispatch({ type: ACTIONS.CALL_API });
    
    const body = {
      rating: getFieldValue(formInfo.data, "rating"),
      feedbackText: getFieldValue(formInfo.data, "comment"),
      sourcePage: getFieldValue(formInfo.data, "sourcePage"),
    };
    
    try {
      const res = await submitFeedback(body);
      const status = res?.data?.status;
      
      if (status !== 1) {
        const message =
          res?.data?.globalErrorMessageList?.[0] ||
          "We couldn’t submit your feedback. Please try again.";
        dispatch({ type: ACTIONS.ERROR, error: res, message });
        return;
      }
      
      dispatch({ type: ACTIONS.SUCCESS, message: "" });
    } catch (err) {
      const message =
        err?.data?.globalErrorMessageList?.[0] ||
        "We couldn’t submit your feedback. Please try again!";
      dispatch({ type: ACTIONS.ERROR, error: err, message });
    }
  };
  
  // const RatingButton = ({
  //                         selected,
  //                         onClick,
  //                         label,
  //                         iconDefault,
  //                         iconSelected,
  //                         ariaLabel,
  //                       }) => (
  //   <button
  //     type="button"
  //     onClick={onClick}
  //     onKeyDown={(e) => (e.key === "Enter" || e.key === " " ? onClick() : null)}
  //     className="d-flex flex-column align-items-center justify-content-center"
  //     aria-pressed={selected}
  //     aria-label={ariaLabel}
  //     style={{
  //       background: selected ? "#E7F3FF" : "#FFF",
  //       border: "#FFF",
  //       borderRadius: 7,
  //       padding: "12px 16px",
  //       width: 120,
  //       cursor: "pointer",
  //     }}
  //   >
  //     <div style={{ fontSize: 20, lineHeight: "20px" }}>
  //       {selected ? iconSelected : iconDefault}
  //     </div>
  //   </button>
  // );
  
  const RatingButton = ({
                          selected,
                          onClick,
                          iconDefault,
                          iconSelected,
                          ariaLabel,
                        }) => {
    const [hovered, setHovered] = useState(false);
    
    return (
      <button
        type="button"
        onClick={onClick}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " " ? onClick() : null)}
        className="d-flex flex-column align-items-center justify-content-center"
        aria-pressed={selected}
        aria-label={ariaLabel}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onFocus={() => setHovered(true)}
        onBlur={() => setHovered(false)}
        style={{
          background: (selected) ? "#E7F3FF" : "#FFF",
          border: "#FFF",
          borderRadius: 7,
          padding: "12px 16px",
          width: 120,
          cursor: "pointer",
        }}
      >
        <div style={{fontSize: 20, lineHeight: "20px"}}>
          {(selected || hovered) ? iconSelected : iconDefault}
        </div>
      </button>
    );
  };
  
  return (
    <Modal show={show} onHide={onHide} centered restoreFocus>
      <Modal.Header className={`m-1 p-2 border-bottom-0`}>
        <CloseButton
          ref={closeBtnRef}
          aria-label="Close"
          onClick={onHide}
        />
      </Modal.Header>
      
      <Modal.Body>
        {isFormView &&
          <Modal.Title className={`pb-5`}>We welcome your feedback!</Modal.Title>
        }
        {!isFormView &&
          <Modal.Title className={`pb-3`}>We welcome your feedback!</Modal.Title>
        }
        {isSuccessView &&
          <div className="text-start">
            {formInfo?.data?.rating?.selectedValue === 1 ? (
              <PageInfo
                type="success"
                classes="mb-0"
                message={
                <>
                  <p className="body font-weight-bold">
                    Your response has been recorded.
                  </p>
                  <p className={`body`}>Thank you for your positive feedback! We're glad you having a great experience.</p>
                </>
              }
              />
            ) : (
              <PageInfo
                type="success"
                classes="mb-0"
                message={
                <>
                  <p className="body font-weight-bold">
                    Your response has been recorded.
                  </p>
                  <p className="body">
                    Thank you for your feedback. If you need further assistance, contact us at{" "}
                    <a href="mailto:support@psoppc.org">support@psoppc.org</a>.
                  </p>
                </>
                }
              />
            )}
          </div>
        }
        
        {isErrorView && (
          <div className="text-start">
            <PageInfo
              type="error"
              classes="mb-3"
              message={formInfo?.data?.submitView?.message}
            />
          </div>
        )}
        {!isSuccessView && (
          <Form>
            <Form.Group className="mb-3" role="radiogroup" aria-label="Feedback rating">
              <Row className="g-3 justify-content-center">
                <p className="body text-center mb-0 pt-1">
                  Did you find what you were looking for?
                </p>
                <Col xs="auto">
                  <RatingButton
                    selected={ratingSelected === 1}
                    onClick={() => handleRatingSelect(1)}
                    label="Like"
                    iconDefault={like}
                    iconSelected={likeSelected}
                    ariaLabel="Like this page"
                  />
                </Col>
                <Col xs="auto">
                  <RatingButton
                    selected={ratingSelected === 0}
                    onClick={() => handleRatingSelect(0)}
                    label="Dislike"
                    iconDefault={dislike}
                    iconSelected={dislikeSelected}
                    ariaLabel="Dislike this page"
                  />
                </Col>
              </Row>
              {formInfo.data.rating.validation.isInvalid &&
                formInfo.data.rating.validation.errors.map((e, i) => (
                  <div key={`rating-err-${i}`} className="text-danger mt-2 text-center">
                    {e}
                  </div>
                ))}
            </Form.Group>
            
            <Form.Group className="mb-0">
              <Form.Control
                as="textarea"
                rows={4}
                value={comment}
                onChange={handleCommentChange}
                aria-describedby="feedback-comment-help"
                aria-label="Additional comments"
                className="body"
                placeholder="How was your experience? (Optional)"
                maxLength={MAX_LEN}
                style={{height:'140px'}}
              />
              <div className="d-flex justify-content-end mt-1">
                <small id="feedback-comment-help"
                       className={comment.length === MAX_LEN ? " " : "text-muted"}
                       style={
                  comment.length === MAX_LEN ? {color: 'red'} : {}
                }>
                  {comment.length}/{MAX_LEN} characters
                </small>
              </div>
              {formInfo.data.comment.validation.isInvalid &&
                formInfo.data.comment.validation.errors.map((e, i) => (
                  <div key={`comment-err-${i}`} className="text-danger mt-2">
                    {e}
                  </div>
                ))}
            </Form.Group>
          </Form>
        )}
      </Modal.Body>
      
      <Modal.Footer className={`border-top-0`}>
        <>
          {!isSuccessView && (
          <TextButton
            ref={submitBtnRef}
            variant="normal"
            onClick={handleSubmit}
            content={formInfo.loading ? "Submitting" : "Submit"}
            disabled={formInfo.loading}
            className={'m-1 p-2'}
          />
          )}
        </>
      </Modal.Footer>
    </Modal>
  );
};

export default FeedbackModal;
